// import { Service } from 'vue-di-container';

// @Service()
// export default class TokenService {
//     public async getToken(): Promise<string> {
//         return localStorage.token;
//     }
//     public async setToken(token: string) {
//         localStorage.token = token;
//     }

// }
import { Service } from 'vue-di-container';

@Service()
export default class TokenService {

    private static callCount = 0;

    public async getToken(): Promise<string | null> {

        
        const storedToken = localStorage.getItem('token');
        
        return storedToken;
    }

    public async setToken(token: string): Promise<void> {
        try {
            if (!token || !token.trim()) {
                localStorage.removeItem('token');
                return;
            }
            TokenService.callCount++;
            localStorage.setItem('token', token);
            const existingToken = await this.getToken();
            if (existingToken === token) {
                return;
            }
        } catch (error) {
            console.error('❌ Error storing token in localStorage:', error);
        }
    }

    public async removeToken(): Promise<void> {
        localStorage.removeItem('token');
    }
}